import { RouterProvider } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR as ptBRDosCalendarios } from '@mui/x-date-pickers/locales';
import { ptBR } from 'date-fns/locale';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { AuthProvider } from 'contexts/AuthContext';
import { SnackbarProvider } from 'contexts/SnackbarContext';
import { ConfirmProvider } from 'contexts/ConfirmContext';
import AvisoSessaoExpirando from 'modules/auth/components/AvisoSessaoExpirando';
import SessaoEncerradaDialog from 'modules/auth/components/SessaoEncerradaDialog';
import { msalInstance } from 'modules/auth/services/msalConfig';

// Os textos dos campos de data e dos calendários em português: as partes da data (Dia, Mês, Ano), os botões e os
// avisos para o leitor de tela. O formato das datas vem do locale do date-fns (adapterLocale).
const TEXTOS_DOS_CALENDARIOS = ptBRDosCalendarios.components.MuiLocalizationProvider.defaultProps.localeText;

// ==============================|| ROCKY - APP ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={TEXTOS_DOS_CALENDARIOS}>
        <ScrollTop>
          <MsalProvider instance={msalInstance}>
            <AuthProvider>
              <SnackbarProvider>
                <ConfirmProvider>
                  <RouterProvider router={router} />
                </ConfirmProvider>
              </SnackbarProvider>
              <AvisoSessaoExpirando />
              <SessaoEncerradaDialog />
            </AuthProvider>
          </MsalProvider>
        </ScrollTop>
      </LocalizationProvider>
    </ThemeCustomization>
  );
}
